import React from 'react';

function ColorKey({ type, text, ...restProps }){
    return <div className="mc-color-key" {...restProps}>
        <span className={`mc-color-key-badge mc-color-key-badge-${type}`} />
        <span>{text}</span>
    </div>
}

export default ColorKey;